import { Chip, MenuItem, Select } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const StatusCell = ({
  params,
  setSelectedRow,
  setOpenSendNotificationModal,
}) => {
  return (
    <Select
      value={params.value}
      renderValue={(value) => (
        <Chip
          icon={value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
          label={value === 1 ? "Yes" : "No"}
          color={value === 1 ? "success" : "default"}
          variant="outlined"
          size="small"
        />
      )}
      label="Status"
      onChange={() => {
        // Only open modal if is_sent is 0 (No)
        if (params.value === 0) {
          setSelectedRow(params.row);
          setOpenSendNotificationModal(true);
        }
      }}
      disabled={params.value === 1} // Disable if already sent (is_sent = 1)
      sx={{
        height: "100%",
        minHeight: "52px",
        border: "none",
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&.Mui-disabled": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <MenuItem value={1}>
        <Chip label="Yes" color="success" size="small" />
      </MenuItem>
      <MenuItem value={0}>
        <Chip label="No" color="default" size="small" />
      </MenuItem>
    </Select>
  );
};

export default StatusCell;
